import { render, staticRenderFns } from "./StrategyModeSelect.vue?vue&type=template&id=0bcdb750&scoped=true&"
import script from "./StrategyModeSelect.vue?vue&type=script&lang=js&"
export * from "./StrategyModeSelect.vue?vue&type=script&lang=js&"
import style0 from "./StrategyModeSelect.vue?vue&type=style&index=0&id=0bcdb750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdb750",
  null
  
)

export default component.exports